import { render } from "./APIKeys.vue?vue&type=template&id=09f55764"
import script from "./APIKeys.vue?vue&type=script&lang=js"
export * from "./APIKeys.vue?vue&type=script&lang=js"
script.render = render

export default script